var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Dialog } from "radix-ui";
import { Cross2Icon } from "@radix-ui/react-icons";
import { ItemCustomizationDialog } from "../itemCustomization";
import { RadixBadge } from "../primitives/RadixBadge";
import { RadixButton } from "../primitives/RadixButton";
import { RadixDialogue } from "../primitives/RadixDialogue";
import { useCart, useMarketing, useUI } from "../../providers";
import client from "../../http/client";
import { shouldDisplayMenuEntity } from "../utility/menuItemVisibility";
import "./suggestiveSellDialog.css";
var DEBUG_MODE = false;
var CHECKOUT_UPSELL_DISMISSAL_STORAGE_KEY = "checkout-upsell-last-shown-at";
var CHECKOUT_UPSELL_DISMISSAL_WINDOW_MS = 24 * 60 * 60 * 1000;
var getSessionCategories = function () {
    var globalSession = window.session;
    if (!Array.isArray(globalSession === null || globalSession === void 0 ? void 0 : globalSession.categories)) {
        return [];
    }
    return globalSession.categories.filter(function (entry) {
        return Boolean(entry && typeof entry === "object");
    });
};
var getSessionItemNavigations = function () {
    var globalSession = window.session;
    if (!Array.isArray(globalSession === null || globalSession === void 0 ? void 0 : globalSession.item_navigations)) {
        return [];
    }
    return globalSession.item_navigations.filter(function (entry) {
        return Boolean(entry && typeof entry === "object");
    });
};
var getSessionMenuIdByItemNavigationId = function (itemNavigationId) {
    if (Number.isNaN(itemNavigationId)) {
        return null;
    }
    var match = getSessionItemNavigations().find(function (navigation) {
        return Number(navigation === null || navigation === void 0 ? void 0 : navigation.id) === itemNavigationId;
    });
    if ((match === null || match === void 0 ? void 0 : match.menu_id) === null || typeof (match === null || match === void 0 ? void 0 : match.menu_id) === "undefined") {
        return null;
    }
    var menuId = Number(match.menu_id);
    return Number.isNaN(menuId) ? null : menuId;
};
var resolveSuggestiveSellItemDetails = function (upsellMenuItemId) {
    var _a;
    var categories = getSessionCategories();
    for (var categoryIndex = 0; categoryIndex < categories.length; categoryIndex += 1) {
        var category = categories[categoryIndex];
        var itemNavigations = Array.isArray(category.item_navigations) ? category.item_navigations : [];
        var itemMatch = itemNavigations.find(function (itemNavigation) {
            return Number(itemNavigation === null || itemNavigation === void 0 ? void 0 : itemNavigation.menu_id) === upsellMenuItemId && shouldDisplayMenuEntity(itemNavigation);
        });
        if (!itemMatch) {
            continue;
        }
        var categoryId = Number(category.id);
        if (Number.isNaN(categoryId)) {
            return null;
        }
        var itemNavigationId = Number(itemMatch === null || itemMatch === void 0 ? void 0 : itemMatch.id);
        if (Number.isNaN(itemNavigationId)) {
            return null;
        }
        return {
            upsellMenuItemId: upsellMenuItemId,
            categoryId: categoryId,
            itemName: ((_a = itemMatch === null || itemMatch === void 0 ? void 0 : itemMatch.name) === null || _a === void 0 ? void 0 : _a.trim()) || "Recommended item",
            imageUrl: (itemMatch === null || itemMatch === void 0 ? void 0 : itemMatch.imageURL) || "",
            itemNavigationId: itemNavigationId,
        };
    }
    return null;
};
var buildDefaultPayloadFromItemResponse = function (itemResponse, categoryResponse) {
    var itemGroup = itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.item_group;
    var itemGroupItems = Array.isArray(itemGroup === null || itemGroup === void 0 ? void 0 : itemGroup.items) ? itemGroup.items : [];
    var selectedItemIndex = itemGroupItems.findIndex(function (itemGroupItem) {
        return shouldDisplayMenuEntity(itemGroupItem);
    });
    if (selectedItemIndex < 0) {
        return {
            payload: null,
            hasDefaultsForRequiredStyles: false,
        };
    }
    var selectedItem = itemGroupItems[selectedItemIndex];
    var modificationGroups = Array.isArray(itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.modification_groups) ? itemResponse.modification_groups : [];
    var chosenIncludedModifiers = {};
    var chosenModifiers = {
        0: {
            quantity: 1,
            portion: "whole",
            size: "normal",
        },
    };
    var modifiers = [];
    var hasDefaultsForRequiredStyles = true;
    modificationGroups.forEach(function (group) {
        var groupModifications = Array.isArray(group === null || group === void 0 ? void 0 : group.modifications) ? group.modifications : [];
        if ((group === null || group === void 0 ? void 0 : group.control_type) === "radio") {
            var hasSelectedDefault = groupModifications.some(function (modification) {
                return Number((modification === null || modification === void 0 ? void 0 : modification.selected_quantity) || 0) > 0;
            });
            if (!hasSelectedDefault) {
                hasDefaultsForRequiredStyles = false;
            }
        }
        groupModifications.forEach(function (modification) {
            var modifierId = Number(modification === null || modification === void 0 ? void 0 : modification.id);
            if (Number.isNaN(modifierId)) {
                return;
            }
            var includedQuantity = Number((modification === null || modification === void 0 ? void 0 : modification.included_quantity) || 0);
            var selectedQuantity = Number((modification === null || modification === void 0 ? void 0 : modification.selected_quantity) || 0);
            if (includedQuantity > 0) {
                chosenIncludedModifiers[String(modifierId)] = {
                    portion: "whole",
                    quantity: includedQuantity,
                    size: "normal",
                };
                modifiers.push({
                    id: modifierId,
                    quantity: includedQuantity,
                    portion: "whole",
                    size: "normal",
                });
            }
            chosenModifiers[String(modifierId)] = {
                quantity: selectedQuantity,
                portion: "whole",
                size: "normal",
            };
            if (selectedQuantity > 0) {
                modifiers.push({
                    id: modifierId,
                    quantity: selectedQuantity,
                    portion: "whole",
                    size: "normal",
                });
            }
        });
    });
    return {
        payload: {
            item: selectedItem.id,
            quantity: 1,
            modifiers: modifiers,
            addOns: [],
            itemNavigation: itemResponse.id,
            choices: JSON.stringify({
                includedModifiers: chosenIncludedModifiers,
                item: selectedItemIndex,
                modifiers: chosenModifiers,
                addOns: {},
                category: (categoryResponse === null || categoryResponse === void 0 ? void 0 : categoryResponse.name) || "None",
            }),
            comment: "",
            category_id: (categoryResponse === null || categoryResponse === void 0 ? void 0 : categoryResponse.id) || 0,
        },
        hasDefaultsForRequiredStyles: hasDefaultsForRequiredStyles,
    };
};
var getCheckoutUpsellLastShownAt = function () {
    if (typeof window === "undefined") {
        return null;
    }
    var rawValue = window.localStorage.getItem(CHECKOUT_UPSELL_DISMISSAL_STORAGE_KEY);
    if (!rawValue) {
        return null;
    }
    var timestamp = Number(rawValue);
    if (!Number.isFinite(timestamp) || timestamp <= 0) {
        return null;
    }
    return timestamp;
};
var hasCheckoutUpsellCooldown = function () {
    var lastShownAt = getCheckoutUpsellLastShownAt();
    if (!lastShownAt) {
        return false;
    }
    return Date.now() - lastShownAt < CHECKOUT_UPSELL_DISMISSAL_WINDOW_MS;
};
var markCheckoutUpsellShown = function () {
    if (typeof window === "undefined") {
        return;
    }
    window.localStorage.setItem(CHECKOUT_UPSELL_DISMISSAL_STORAGE_KEY, String(Date.now()));
};
export var SuggestiveSellDialog = function () {
    var marketingData = useMarketing().marketingData;
    var _a = useCart(), items = _a.items, getCart = _a.getCart;
    var _b = useUI(), suggestiveSellRequest = _b.suggestiveSellRequest, closeSuggestiveSell = _b.closeSuggestiveSell, showToast = _b.showToast;
    var _c = useState([]), suggestiveSellOptions = _c[0], setSuggestiveSellOptions = _c[1];
    var _d = useState(null), loadingUpsellId = _d[0], setLoadingUpsellId = _d[1];
    var _e = useState(null), upsellCustomizationTarget = _e[0], setUpsellCustomizationTarget = _e[1];
    var cartMenuItemIds = useMemo(function () {
        return items.reduce(function (accumulator, cartLine) {
            var lineItemNavigationId = Number(cartLine.item_navigation_id);
            var lineMenuId = getSessionMenuIdByItemNavigationId(lineItemNavigationId);
            if (lineMenuId !== null) {
                accumulator.add(lineMenuId);
            }
            return accumulator;
        }, new Set());
    }, [items]);
    var getEligibleOptions = useCallback(function (menuItemIdsInCart, requestMenuId, requestSource) {
        var menuUpsellItems = Array.isArray(marketingData.menuUpsellItems)
            ? marketingData.menuUpsellItems
            : [];
        if (DEBUG_MODE) {
            return menuUpsellItems
                .map(function (upsellItem) {
                var upsellMenuItemId = Number(upsellItem.upsellMenuItemId);
                var details = resolveSuggestiveSellItemDetails(upsellMenuItemId);
                if (!details) {
                    return null;
                }
                return __assign(__assign({}, details), { description: String(upsellItem.description || "Recommended") });
            })
                .filter(function (option) { return Boolean(option); });
        }
        if (requestSource === "checkout" && hasCheckoutUpsellCooldown()) {
            return [];
        }
        return menuUpsellItems
            .filter(function (upsellItem) {
            var upsellMenuItemId = Number(upsellItem.upsellMenuItemId);
            if (Number.isNaN(upsellMenuItemId) || menuItemIdsInCart.has(upsellMenuItemId)) {
                return false;
            }
            if (requestSource === "checkout") {
                return Boolean(upsellItem.upsellOnAllMenuItems);
            }
            if (requestMenuId === null || upsellItem.upsellOnAllMenuItems) {
                return false;
            }
            var soldMenuItemId = Number(upsellItem.soldMenuItemId);
            return Number.isFinite(soldMenuItemId) && soldMenuItemId === requestMenuId;
        })
            .map(function (upsellItem) {
            var upsellMenuItemId = Number(upsellItem.upsellMenuItemId);
            var details = resolveSuggestiveSellItemDetails(upsellMenuItemId);
            if (!details) {
                return null;
            }
            return __assign(__assign({}, details), { description: String(upsellItem.description || "Recommended") });
        })
            .filter(function (option) { return Boolean(option); });
    }, [marketingData.menuUpsellItems]);
    useEffect(function () {
        if (!suggestiveSellRequest) {
            setSuggestiveSellOptions([]);
            return;
        }
        var menuItemIdsInCart = new Set(cartMenuItemIds);
        var requestItemNavigationId = Number(suggestiveSellRequest.itemNavigationId);
        var requestMenuId = null;
        if (!Number.isNaN(requestItemNavigationId)) {
            requestMenuId = getSessionMenuIdByItemNavigationId(requestItemNavigationId);
            if (requestMenuId !== null) {
                menuItemIdsInCart.add(requestMenuId);
            }
        }
        var eligibleOptions = getEligibleOptions(menuItemIdsInCart, requestMenuId, suggestiveSellRequest.source);
        if (!DEBUG_MODE && eligibleOptions.length === 0) {
            closeSuggestiveSell();
            return;
        }
        if (!DEBUG_MODE && suggestiveSellRequest.source === "checkout") {
            markCheckoutUpsellShown();
        }
        setSuggestiveSellOptions(eligibleOptions);
    }, [cartMenuItemIds, closeSuggestiveSell, getEligibleOptions, suggestiveSellRequest]);
    var handleAddSuggestiveSellItem = useCallback(function (option) { return __awaiter(void 0, void 0, void 0, function () {
        var itemApiUrl, itemResponseRequest, itemResponseJson, itemResponse, categoryResponse, _a, payload, hasDefaultsForRequiredStyles, _error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoadingUpsellId(option.upsellMenuItemId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    itemApiUrl = "".concat(window.relativeURI(), "/menu/categories/").concat(option.categoryId, "/items/").concat(option.itemNavigationId, "/api");
                    return [4 /*yield*/, fetch(itemApiUrl, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            },
                            credentials: "same-origin",
                        })];
                case 2:
                    itemResponseRequest = _b.sent();
                    if (!itemResponseRequest.ok) {
                        throw new Error("Unable to load suggestive sell item.");
                    }
                    return [4 /*yield*/, itemResponseRequest.json()];
                case 3:
                    itemResponseJson = _b.sent();
                    itemResponse = itemResponseJson === null || itemResponseJson === void 0 ? void 0 : itemResponseJson.item;
                    categoryResponse = (itemResponseJson === null || itemResponseJson === void 0 ? void 0 : itemResponseJson.category) || null;
                    _a = buildDefaultPayloadFromItemResponse(itemResponse, categoryResponse), payload = _a.payload, hasDefaultsForRequiredStyles = _a.hasDefaultsForRequiredStyles;
                    if (!payload) {
                        throw new Error("Suggestive sell item payload is invalid.");
                    }
                    if (!hasDefaultsForRequiredStyles) {
                        setUpsellCustomizationTarget({
                            itemUrl: "".concat(window.relativeURI(), "/menu/categories/").concat(option.categoryId, "/items/").concat(option.itemNavigationId),
                            title: option.itemName,
                        });
                        closeSuggestiveSell();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, client.post("/cart/add/api", payload)];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, getCart()];
                case 5:
                    _b.sent();
                    showToast("".concat(option.itemName, " added to cart."), "success");
                    closeSuggestiveSell();
                    return [3 /*break*/, 8];
                case 6:
                    _error_1 = _b.sent();
                    setUpsellCustomizationTarget({
                        itemUrl: "".concat(window.relativeURI(), "/menu/categories/").concat(option.categoryId, "/items/").concat(option.itemNavigationId),
                        title: option.itemName,
                    });
                    closeSuggestiveSell();
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingUpsellId(null);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [closeSuggestiveSell, getCart, showToast]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RadixDialogue, { open: Boolean(suggestiveSellRequest), onOpenChange: function (nextOpen) {
                if (!nextOpen) {
                    closeSuggestiveSell();
                }
            }, overlayClassName: "radix-modal-overlay", contentClassName: "suggestive-sell-dialog-content" },
            React.createElement("div", { className: "suggestive-sell-dialog-header" },
                React.createElement(Dialog.Title, { className: "suggestive-sell-dialog-title" }, "You might also like:"),
                React.createElement(Dialog.Close, { className: "radix-flyout-close", "aria-label": "Close suggestive sell dialogue." },
                    React.createElement(Cross2Icon, null))),
            React.createElement("div", { className: "suggestive-sell-dialog-body" },
                suggestiveSellOptions.length === 0 ? (React.createElement("p", { className: "suggestive-sell-empty", role: "status", "aria-live": "polite" }, "No upsell items are available.")) : null,
                suggestiveSellOptions.map(function (option) { return (React.createElement("article", { className: "suggestive-sell-card", key: "".concat(option.upsellMenuItemId, "-").concat(option.description) },
                    option.imageUrl ? (React.createElement("img", { src: option.imageUrl, alt: option.itemName, className: "suggestive-sell-image" })) : null,
                    React.createElement("div", { className: "suggestive-sell-content" },
                        React.createElement(RadixBadge, { className: "suggestive-sell-description-badge", text: option.description, backgroundColor: "var(--ui-color-danger-soft)", borderColor: "var(--ui-color-danger-border)", fontColor: "var(--ui-color-danger-strong)" }),
                        React.createElement("h3", { className: "suggestive-sell-item-title" }, option.itemName),
                        React.createElement(RadixButton, { className: "suggestive-sell-add-button", disabled: loadingUpsellId === option.upsellMenuItemId, "aria-label": "Add ".concat(option.itemName, " to cart"), "aria-busy": loadingUpsellId === option.upsellMenuItemId, onClick: function () {
                                handleAddSuggestiveSellItem(option).catch(function () {
                                    setLoadingUpsellId(null);
                                });
                            } },
                            React.createElement("span", null, loadingUpsellId === option.upsellMenuItemId ? "ADDING..." : "ADD TO CART"))))); }))),
        React.createElement(ItemCustomizationDialog, { open: Boolean(upsellCustomizationTarget), onOpenChange: function (nextOpen) {
                if (!nextOpen) {
                    setUpsellCustomizationTarget(null);
                }
            }, itemUrl: (upsellCustomizationTarget === null || upsellCustomizationTarget === void 0 ? void 0 : upsellCustomizationTarget.itemUrl) || null, title: (upsellCustomizationTarget === null || upsellCustomizationTarget === void 0 ? void 0 : upsellCustomizationTarget.title) || "Customize item", editMode: false })));
};
